import { render, staticRenderFns } from "./ParticaWebsiteCard.vue?vue&type=template&id=68861df0&scoped=true&"
import script from "./ParticaWebsiteCard.vue?vue&type=script&lang=ts&"
export * from "./ParticaWebsiteCard.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaWebsiteCard.vue?vue&type=style&index=0&id=68861df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68861df0",
  null
  
)

export default component.exports